//Imports node_modules
import React, { useContext, useEffect, useState, useCallback } from 'react'
import Modal from 'react-modal';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Imports Css
import './ProductionWorkListPage.css'

//Import Components
import TopBar from '../../../components/Global/topBar/TopBar';
import ObraCard from '../../../components/layout/obraCard/ObraCard';

//Import Data
import { globalVariables } from '../../../data/GlobalVariables'
import { globalModals } from '../../../data/GlobalModals'
import SearchBar from '../../../components/Global/searchBar/SearchBar';



//Pagina onde o cliente selciona a entidade
const ProductionWorkListPage = (props) => {

    //--- Variaveis

    //Variaveis Locais
    const {
        apiBaseUrl,
        setObra,
        zone,
        setSelectedObraForGroupProduction,
    } = useContext(globalVariables)

    const {
        ShowMessageModal,
    } = useContext(globalModals);

    const [response, setResponse] = useState([])
    const [searchString, setSearchString] = useState('')

    const queryParams = new URLSearchParams(window.location.search);

    const navigate = useNavigate();

    //--- Fim variaveis 

    //--- Funções

    //----- Funções Top Bar  
    function nextBtnClick() {
    }

    function backbtnClick() {
        if (queryParams.get('groupProduction') || queryParams.get('groupEditProduction')) {
            navigate('/groupProductionPage')
        } else {
            navigate('/zonePage?back=true')
        }
    }

    //----- Fim Funções Top Bar  

    const currentZone = useCallback(function (obra) {
        if (queryParams.get('groupProduction')) {
            setSelectedObraForGroupProduction(obra)
            localStorage.setItem("queryParams", "addProject");
            navigate('/groupProductionPage')
        } else {
            if(queryParams.get('groupEditProduction')){
                setSelectedObraForGroupProduction(obra)
                localStorage.setItem("queryParams", "editProject");
                navigate('/groupProductionPage')
            }else{
                setObra(obra);
                navigate('/productionPage?newprod=true')
            }
            
        }

    }, [navigate, setObra])

    function getUserList(states) {
        return states.map((state, index) =>
            <ObraCard key={index} obra={state} onClick={currentZone}></ObraCard>
        )
    }

    useEffect(() => {
        //Query para ler os funçionarios/grupos que o dispositivo tem acesso
        var searchStringToSend;

        if (searchString === '' || searchString === 'undefinded') {
            searchStringToSend = 'noSearchString'
        } else {
            searchStringToSend = searchString;
        }

        getObra(searchStringToSend, false);

        // eslint-disable-next-line
    }, [apiBaseUrl, searchString]);

    function getObra(receivedString, isEnter) {

        receivedString = receivedString.replace("#", "");
        receivedString = receivedString.replace("+", "");
        receivedString = receivedString.replace("&", "");

        if (receivedString === '' || receivedString === 'undefinded' || receivedString.trim() === '') {
            receivedString = 'noSearchString'
        }

        axios.post(apiBaseUrl + 'Production/selectObras?num_centroTrabalho=' + zone.nctt + '&searchString=' + receivedString, { timeout: 50000 }).then((response) => {

            const isDataAvailable = response.data && response.data.length;
            if (isDataAvailable) {

                const myJSON = JSON.stringify(response.data);
                if (myJSON.slice(0, 6) === '"Erro:') {
                    ShowMessageModal(
                        {
                            modaltype: 'error',
                            modalTitle: 'Erro a ler as opções',
                            modalMessage: response.data,
                            nextClick: 'dismiss',
                            nextBtnTxt: 'Compreendi',
                            crossClick: 'dismiss',
                        })
                } else {
                    //Operação a executar
                    if (isEnter) {
                        if (response.data.length === 1) {
                            setObra(response.data[0]);
                            navigate('/productionPage?newprod=true')
                        }
                        if (response.data.length === 0) {

                            document.getElementById("search").select();

                            toast.warn('Não foram encontrados resgistos!', {
                                position: "top-right",
                                autoClose: 2000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }

                        if (response.data.length > 1) {

                            document.getElementById("search").select();
                            document.getElementById("search").select();
                            toast.warn('Foram encontrados múltiplos registos!', {
                                position: "top-right",
                                autoClose: 2000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }
                    } else {
                        if (isEnter) {
                            document.getElementById("search").select();
                            toast.warn('Não foram encontrados resgistos!', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }
                        setResponse(response.data);
                    }
                }
            } else {
                if (isEnter) {
                    document.getElementById("search").select();
                    toast.warn('Não foram encontrados resgistos!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                setResponse(response.data);
            }

        }, (error) => {
            ShowMessageModal(
                {
                    modaltype: 'error',
                    modalTitle: 'Erro a ler as opções',
                    modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
        });
    }

    //--- Fim funções

    //--- Fim Desenvolvimento teste

    //Para não dar erro no modal
    Modal.setAppElement('body');

    const changeSearchString = useCallback(function (value) {
        setSearchString(value)
    }, [setSearchString])

    const onEnterZone = useCallback(function () {
        let xActiveEl = document.getElementById('search')
        let xValue = xActiveEl.value;
        getObra(xValue, true)
    }, [navigate, response])

    return (
        <div className="ProductionWorkListPage" style={{ height: '100vh' }}>
            <div className='topbar'>
                <TopBar texto='Escolha a obra:' type='blue' backText='Voltar' nextBtnClick={nextBtnClick} backbtnClick={backbtnClick} layout='1'></TopBar>
            </div>

            <div className="pageContent" style={{ position: "fixed" }}>
                <div style={{ marginBottom: '20px', marginTop: '54px' }}>
                    <h3 style={{ margin: '0px' }}>Pesquisar:</h3>
                    <SearchBar
                        valor={searchString}
                        searchBtn={false}
                        cleanBtn={true}
                        click={e => console.log('teste')}
                        pesqType={'productList'}
                        readonly={false}
                        currentPesquisa={changeSearchString}
                        currentEnter={onEnterZone}
                    >
                    </SearchBar>
                </div>

                <div className='flexLayoutScrollable'>
                    {getUserList(response)}
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    )
}
export default ProductionWorkListPage